"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSubmitBooking = exports.canSubmitMeetingTime = exports.canSubmitPropertyForm = exports.canSubmitStagedPropertyForm = exports.canSubmitInitialPropertyForm = void 0;

var _reselect = require("reselect");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _FormFieldValidationSelector = require("MeetingsLib/selectors/FormFieldValidationSelector");

var _LegalConsentFormSelectors = require("./LegalConsentFormSelectors");

var _get = _interopRequireDefault(require("transmute/get"));

var forcePropertyFormIfInitialFormComplete = (0, _get.default)('forcePropertyForm');

var checkAllFormValidation = function checkAllFormValidation(formStateValidation) {
  if (!formStateValidation) {
    return false;
  }

  var customFieldsInvalid = formStateValidation.get('customFormFields').filter(function (fieldValidation) {
    return Boolean(fieldValidation);
  }).size > 0;
  var isEmailInvalid = Boolean(formStateValidation.get('email'));
  var isFirstNameInvalid = Boolean(formStateValidation.get('firstName'));
  var isLastNameInvalid = Boolean(formStateValidation.get('lastName'));
  return !(customFieldsInvalid || isEmailInvalid || isFirstNameInvalid || isLastNameInvalid);
};

var canSubmitInitialPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getInitialFormFieldValidation, forcePropertyFormIfInitialFormComplete, _BookInfoSelectors.getShouldAutoSubmit], function (formFieldValidation, forcePropertyForm, shouldAutoSubmit) {
  return (forcePropertyForm === false || shouldAutoSubmit) && checkAllFormValidation(formFieldValidation);
});
exports.canSubmitInitialPropertyForm = canSubmitInitialPropertyForm;
var canSubmitStagedPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getStagedFormFieldValidation], checkAllFormValidation);
exports.canSubmitStagedPropertyForm = canSubmitStagedPropertyForm;
var canSubmitPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getFormFieldValidation], checkAllFormValidation);
exports.canSubmitPropertyForm = canSubmitPropertyForm;
var canSubmitMeetingTime = (0, _reselect.createSelector)([_BookInfoSelectors.getEvent], function (event) {
  return Boolean(event.dateTime);
});
exports.canSubmitMeetingTime = canSubmitMeetingTime;
var canSubmitBooking = (0, _reselect.createSelector)([canSubmitMeetingTime, canSubmitPropertyForm, _LegalConsentFormSelectors.getAllRequiredConsentCollected], function (meetingTimeValid, propertyFormValid, legalConsentValid) {
  return meetingTimeValid && propertyFormValid && legalConsentValid;
});
exports.canSubmitBooking = canSubmitBooking;